import { ContactMethod, AvailabilityStatus, Testimonial } from '../types';

export const defaultContactMethods: ContactMethod[] = [
    {
        id: '1',
        type: 'email',
        label: 'Email',
        value: 'jabez.kifle@gmail.com',
        icon: 'Mail',
        description: 'Direct line for technical synchronization and project inquiries.'
    },
    {
        id: '2',
        type: 'phone',
        label: 'Voice Sync',
        value: '+251 900 000 000',
        icon: 'Phone',
        description: 'Operational hours: Mon-Fri, 09:00 - 18:00 EAT.'
    },
    {
        id: '3',
        type: 'linkedin',
        label: 'LinkedIn',
        value: 'https://linkedin.com/in/yabets-kifle',
        icon: 'Linkedin',
        description: 'Professional networking and architectural updates.'
    },
    {
        id: '4',
        type: 'location',
        label: 'Deployment Origin',
        value: 'Addis Ababa, Ethiopia',
        icon: 'MapPin',
        description: 'Available for both remote and localized collaborations.'
    }
];

export const defaultAvailability: AvailabilityStatus = {
    status: 'available',
    message: 'Available for high-impact deployments',
    responseTime: '24-48 hours',
    nextAvailable: 'Immediate bandwidth available'
};

export const defaultTestimonials: Testimonial[] = [
    {
        id: '1',
        name: 'Executive Partner',
        company: 'Visionary Systems',
        role: 'Managing Director',
        message: 'Operational efficiency and technical precision. Delivered core infrastructure with outstanding attention to architectural detail.',
        avatar: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7",
        alt: 'Executive portrait',
        rating: 5
    },
    {
        id: '2',
        name: 'Lead Architect',
        company: 'Quantum Tech',
        role: 'Product Lead',
        message: 'Exceptional technical depth. The synchronization between design and performance exceeded our internal benchmarks.',
        avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
        alt: 'Technical lead portrait',
        rating: 5
    }
];

export const defaultFAQs = [
    {
        id: '1',
        question: 'Technical Execution Timeline?',
        answer: 'Standard deployment ranges from 2-4 weeks for focused modules to 8-12 weeks for enterprise-grade applications. Each phase includes a comprehensive audit.'
    },
    {
        id: '2',
        question: 'Protocol for Global Collaboration?',
        answer: 'I maintain synchronization across multiple time zones. Remote collaboration is facilitated through secure uplink and agile methodologies.'
    },
    {
        id: '3',
        question: 'Core Technology Specialization?',
        answer: 'Architectural focus on React, TypeScript, and Node.js. Deep integration with modern cloud infrastructure and high-performance databases.'
    },
    {
        id: '4',
        question: 'Maintenance and Operational Support?',
        answer: 'Post-deployment support includes performance optimization, security audits, and iterative scaling based on project requirements.'
    }
];
